import React from "react";
import { Alert as NBAlert } from "native-base";

const styles = {
    "default": {
        backgroundColor: "#fff",
        color: "inherit",
        borderWidth: 0,
    },
    "success": {
        color: "success.700",
        borderColor: "success.700",
    },
    "warning": {
        color: "warning.900",
        borderColor: "warning.700",
    },
    "error": {
        color: "error.900",
        borderColor: "error.700",
    },
    "info": {
        color: "info.700",
        borderColor: "info.700",
    },
}


export const Alert = (props) => {
    const { status, ...rest } = props;
    return <NBAlert borderWidth="1" color={"white"} {...props} {...styles[status]} />
}